import { Component, OnInit } from '@angular/core';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';

@Component({
  selector: 'app-admin-menu',
  templateUrl: './admin-menu.component.html',
  styleUrls: ['./admin-menu.component.css']
})
export class AdminMenuComponent implements OnInit {
  constructor(private http: HttpClient, private System: TSFuntionService) { }
  public _MenuR = [];
  ngOnInit() {
    this.GetMenuRequest();
  }

  GetMenuRequest() {
    this.System.BlockUI();
    this.http.get<any>("api/_Menu/GetMenuAdmin").subscribe(res => {
      if (res) {
        this._MenuR = res;
      }
      this.System.UnBlockUI();
    });
  }

}


interface _TM_Menu {
  nMenuId: number;
  nMenuHeadId: number;
  sMenuName: string;
  sIcon: string;
  sClass: string;
  nLevel: string;
  sType: string;
  sUrl: string;
  isOpenFile: boolean;
  isActive: boolean;
  isShow: boolean;
  nOrder: number;
}

